import React from 'react';

import { DateCalendar } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';

import type { DateCalendarFieldProps } from './interface';

export const DateCalendarField: React.FC<DateCalendarFieldProps> = ({
  input,
  meta,
  disabled = false,
  ...props
}) => {
  const { value, onChange } = input;

  const handleChange = React.useCallback(
    (date: DateTime | null) => {
      onChange(date);
    },
    [onChange],
  );

  return (
    <DateCalendar
      disabled={disabled}
      value={toCalendarDateTime(value)}
      onChange={handleChange}
      {...props}
    />
  );
};

const toCalendarDateTime = (value: unknown): DateTime | null => {
  if (DateTime.isDateTime(value)) {
    return value;
  }
  if (typeof value === 'string' && value) {
    return DateTime.fromISO(value);
  }
  return null;
};
